import React from 'react'
import styled from 'styled-components'
import {
  Avatar,
  Skeleton,
  SingleColorInstagram as SingleColorInstagramIcon,
  SingleColorFacebook as SingleColorFacebookIcon,
  SingleColorYoutube as SingleColorYoutubeIcon,
  SingleColorTwitter as SingleColorTwitterIcon,
  SingleColorTiktok as SingleColorTiktokIcon
  // @ts-ignore
} from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'
import SocialWebChannelType from 'enums/SocialWebChannelType'
import { getAuthorUrl } from 'utils/sourceUtil'
import Domain from 'enums/Domain'
import { ChannelInfos } from './types'
import { AVATAR_DIAMETER } from './constants'
import ChannelLevelIcon from './ChannelLevelIcon'

const Link = styled.a.attrs({ target: '_blank', rel: 'noopener noreferrer' })`
  color: inherit;
  cursor: ${({ href }) => (href ? 'pointer' : 'default')};
  text-decoration: none;
`

const Name = styled.div`
  word-break: break-word;
`

const IconContainer = styled.div`
  flex: none;
  display: flex;
`

const ChannelTypeToIconComponent = {
  [SocialWebChannelType.TWITTER]: SingleColorTwitterIcon,
  [SocialWebChannelType.FACEBOOK]: SingleColorFacebookIcon,
  [SocialWebChannelType.YOUTUBE]: SingleColorYoutubeIcon,
  [SocialWebChannelType.INSTAGRAM]: SingleColorInstagramIcon,
  [SocialWebChannelType.TIKTOK]: SingleColorTiktokIcon,
  [SocialWebChannelType.OTHER]: () => null
}

const ChannelTypeToDomain = {
  [SocialWebChannelType.TWITTER]: Domain.TWITTER,
  [SocialWebChannelType.FACEBOOK]: Domain.FACEBOOK,
  [SocialWebChannelType.YOUTUBE]: Domain.YOUTUBE,
  [SocialWebChannelType.INSTAGRAM]: Domain.INSTAGRAM,
  [SocialWebChannelType.TIKTOK]: Domain.TIKTOK,
  [SocialWebChannelType.OTHER]: Domain.UNKNOWN
}

interface ProfileProps {
  channelInfos: ChannelInfos
  showChannelTypeIcon?: boolean
}

const Profile = ({
  channelInfos: { channelName, channelType, channelAuthor, channelLevel, image },
  showChannelTypeIcon
}: ProfileProps) => {
  const theme = useDisplayTheme() as Theme
  const ChannelTypeIconComponent = ChannelTypeToIconComponent[channelType]
  const authorUrl = getAuthorUrl(ChannelTypeToDomain[channelType], channelAuthor)

  return (
    <>
      <Link href={authorUrl}>
        <Avatar
          mode={theme}
          variant="circular"
          src={image}
          diameter={AVATAR_DIAMETER}
          loader={
            <Skeleton
              variation="circle"
              width={AVATAR_DIAMETER}
              height={AVATAR_DIAMETER}
              animation="wave"
            />
          }
          alt={channelName}
        />
      </Link>
      {showChannelTypeIcon && (
        <IconContainer>
          <ChannelTypeIconComponent color={sys[theme].text.primary} />
        </IconContainer>
      )}
      <Name>{channelName}</Name>
      <IconContainer>
        <ChannelLevelIcon level={channelLevel} />
      </IconContainer>
    </>
  )
}

export default Profile
